const ServicesHero = () => {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-b from-[#F8F9FA] to-white">
      <div className="max-w-[1280px] mx-auto px-6 text-center">
        <p className="text-[#0066FF] uppercase text-sm font-semibold tracking-wide mb-4">Our Services</p>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0A1628] mb-6 max-w-4xl mx-auto">
          Comprehensive HR solutions for sport
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          From personal brand management to organisational transformation, we deliver specialist HR services designed for the unique demands of the sports industry
        </p>
      </div>
    </section>
  );
};

export default ServicesHero;
